<footer class="footer">
    <div class="row justify-content-center w-100">
      <div class="col-md-3 col-12 d-flex justify-content-md-end justify-content-center align-self-center">
        <p class="footer-text mb-md-0 mb-3">{{'POWERED_BY_PULSE' | translate}}</p>
      </div>
      <div class="col-md-3 col-12">
        <img src="assets/img/pulse-logo.svg" class="powered-logo" alt="">
      </div>
    </div>
  </footer>
